// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container_N8TBP{background:#1c2735;border-radius:8px;overflow:hidden}.title_CPDa7{padding:16px;border-bottom:1px solid #334153;font-size:20px;font-weight:700;line-height:24px;color:#fff}.body_nkcyG{padding:20px 16px}.stats_kVp1Y{padding:12px;background:#232f3f;border-radius:8px}.seller_7bCQo{border-bottom:1px solid #334153}.shortStat_SA4KH{display:grid;grid-template-columns:1fr;grid-gap:12px;margin:12px 0}.stars_E32BN{display:flex;align-items:center;justify-content:flex-start;margin-right:8px}.star_XbcuC{width:20px;height:20px}.starsRow_2Ps1s{display:grid;grid-template-columns:max-content 1fr 60px;grid-gap:12px;align-items:center}.reviewsText_MiT1u{color:#fff;font-size:12px;font-weight:400;line-height:20px;text-align:right}.reviewsLine_XPeZe{width:100%;height:4px;background:#334153;border-radius:4px;overflow:hidden}.reviewsLineFilled_7JpKe{width:0;height:100%;background:#fff000;background:radial-gradient(at center, #FFF000, #FFB11B)}.reviews_oQeuq{display:grid;grid-template-columns:1fr;grid-gap:16px;margin:24px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container_N8TBP",
	"title": "title_CPDa7",
	"body": "body_nkcyG",
	"stats": "stats_kVp1Y",
	"seller": "seller_7bCQo",
	"shortStat": "shortStat_SA4KH",
	"stars": "stars_E32BN",
	"star": "star_XbcuC",
	"starsRow": "starsRow_2Ps1s",
	"reviewsText": "reviewsText_MiT1u",
	"reviewsLine": "reviewsLine_XPeZe",
	"reviewsLineFilled": "reviewsLineFilled_7JpKe",
	"reviews": "reviews_oQeuq"
};
module.exports = ___CSS_LOADER_EXPORT___;
